/**
 * Talmud Daily sponsorship calendar — generated from the program schedule sheet.
 * One entry per sponsor-able day (paused holidays excluded) and per program week.
 * Do not edit by hand; regenerate from the Google Sheet if the schedule changes.
 */

export interface TdDayOption {
  dateISO: string;
  daySlug: string;
  dayNumber: number;
  weekNumber: number;
  seder: string;
  tractate: string;
  voices: boolean;
  label: string;
}

export interface TdWeekOption {
  weekSlug: string;
  weekNumber: number;
  startISO: string;
  endISO: string;
  seder: string;
  tractate: string;
  label: string;
}

export const TD_DAYS: TdDayOption[] = [
  {
    "dateISO": "2026-08-24",
    "daySlug": "day-001",
    "dayNumber": 1,
    "weekNumber": 1,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Mon, Aug 24, 2026 — Foundations"
  },
  {
    "dateISO": "2026-08-25",
    "daySlug": "day-002",
    "dayNumber": 2,
    "weekNumber": 1,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Tue, Aug 25, 2026 — Foundations"
  },
  {
    "dateISO": "2026-08-26",
    "daySlug": "day-003",
    "dayNumber": 3,
    "weekNumber": 1,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Wed, Aug 26, 2026 — Foundations"
  },
  {
    "dateISO": "2026-08-27",
    "daySlug": "day-004",
    "dayNumber": 4,
    "weekNumber": 1,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Thu, Aug 27, 2026 — Foundations"
  },
  {
    "dateISO": "2026-08-28",
    "daySlug": "day-005",
    "dayNumber": 5,
    "weekNumber": 1,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": true,
    "label": "Fri, Aug 28, 2026 — Foundations · Voices"
  },
  {
    "dateISO": "2026-08-31",
    "daySlug": "day-006",
    "dayNumber": 6,
    "weekNumber": 2,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Mon, Aug 31, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-01",
    "daySlug": "day-007",
    "dayNumber": 7,
    "weekNumber": 2,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Tue, Sep 1, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-02",
    "daySlug": "day-008",
    "dayNumber": 8,
    "weekNumber": 2,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Wed, Sep 2, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-03",
    "daySlug": "day-009",
    "dayNumber": 9,
    "weekNumber": 2,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Thu, Sep 3, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-04",
    "daySlug": "day-010",
    "dayNumber": 10,
    "weekNumber": 2,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": true,
    "label": "Fri, Sep 4, 2026 — Foundations · Voices"
  },
  {
    "dateISO": "2026-09-07",
    "daySlug": "day-011",
    "dayNumber": 11,
    "weekNumber": 3,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Mon, Sep 7, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-08",
    "daySlug": "day-012",
    "dayNumber": 12,
    "weekNumber": 3,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Tue, Sep 8, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-09",
    "daySlug": "day-013",
    "dayNumber": 13,
    "weekNumber": 3,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Wed, Sep 9, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-10",
    "daySlug": "day-014",
    "dayNumber": 14,
    "weekNumber": 3,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": false,
    "label": "Thu, Sep 10, 2026 — Foundations"
  },
  {
    "dateISO": "2026-09-11",
    "daySlug": "day-015",
    "dayNumber": 15,
    "weekNumber": 3,
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "voices": true,
    "label": "Fri, Sep 11, 2026 — Foundations · Voices"
  },
  {
    "dateISO": "2026-09-14",
    "daySlug": "day-016",
    "dayNumber": 16,
    "weekNumber": 4,
    "seder": "Zeraim",
    "tractate": "Brachos",
    "voices": false,
    "label": "Mon, Sep 14, 2026 — Brachos"
  },
  {
    "dateISO": "2026-09-15",
    "daySlug": "day-017",
    "dayNumber": 17,
    "weekNumber": 4,
    "seder": "Zeraim",
    "tractate": "Brachos",
    "voices": false,
    "label": "Tue, Sep 15, 2026 — Brachos"
  },
  {
    "dateISO": "2026-09-16",
    "daySlug": "day-018",
    "dayNumber": 18,
    "weekNumber": 4,
    "seder": "Zeraim",
    "tractate": "Brachos",
    "voices": false,
    "label": "Wed, Sep 16, 2026 — Brachos"
  },
  {
    "dateISO": "2026-09-17",
    "daySlug": "day-019",
    "dayNumber": 19,
    "weekNumber": 4,
    "seder": "Zeraim",
    "tractate": "Brachos",
    "voices": false,
    "label": "Thu, Sep 17, 2026 — Brachos"
  },
  {
    "dateISO": "2026-09-18",
    "daySlug": "day-020",
    "dayNumber": 20,
    "weekNumber": 4,
    "seder": "Zeraim",
    "tractate": "Brachos",
    "voices": true,
    "label": "Fri, Sep 18, 2026 — Brachos · Voices"
  },
  {
    "dateISO": "2026-09-20",
    "daySlug": "day-021",
    "dayNumber": 21,
    "weekNumber": 5,
    "seder": "Moed",
    "tractate": "Shabbos",
    "voices": false,
    "label": "Sun, Sep 20, 2026 — Shabbos"
  },
  {
    "dateISO": "2026-09-22",
    "daySlug": "day-022",
    "dayNumber": 22,
    "weekNumber": 5,
    "seder": "Moed",
    "tractate": "Shabbos",
    "voices": false,
    "label": "Tue, Sep 22, 2026 — Shabbos"
  },
  {
    "dateISO": "2026-09-23",
    "daySlug": "day-023",
    "dayNumber": 23,
    "weekNumber": 5,
    "seder": "Moed",
    "tractate": "Shabbos",
    "voices": false,
    "label": "Wed, Sep 23, 2026 — Shabbos"
  },
  {
    "dateISO": "2026-09-24",
    "daySlug": "day-024",
    "dayNumber": 24,
    "weekNumber": 5,
    "seder": "Moed",
    "tractate": "Shabbos",
    "voices": false,
    "label": "Thu, Sep 24, 2026 — Shabbos"
  },
  {
    "dateISO": "2026-09-25",
    "daySlug": "day-025",
    "dayNumber": 25,
    "weekNumber": 5,
    "seder": "Moed",
    "tractate": "Shabbos",
    "voices": true,
    "label": "Fri, Sep 25, 2026 — Shabbos · Voices"
  },
  {
    "dateISO": "2026-09-28",
    "daySlug": "day-026",
    "dayNumber": 26,
    "weekNumber": 6,
    "seder": "Moed",
    "tractate": "Eruvin",
    "voices": false,
    "label": "Mon, Sep 28, 2026 — Eruvin"
  },
  {
    "dateISO": "2026-09-29",
    "daySlug": "day-027",
    "dayNumber": 27,
    "weekNumber": 6,
    "seder": "Moed",
    "tractate": "Eruvin",
    "voices": false,
    "label": "Tue, Sep 29, 2026 — Eruvin"
  },
  {
    "dateISO": "2026-09-30",
    "daySlug": "day-028",
    "dayNumber": 28,
    "weekNumber": 6,
    "seder": "Moed",
    "tractate": "Eruvin",
    "voices": false,
    "label": "Wed, Sep 30, 2026 — Eruvin"
  },
  {
    "dateISO": "2026-10-01",
    "daySlug": "day-029",
    "dayNumber": 29,
    "weekNumber": 6,
    "seder": "Moed",
    "tractate": "Eruvin",
    "voices": false,
    "label": "Thu, Oct 1, 2026 — Eruvin"
  },
  {
    "dateISO": "2026-10-02",
    "daySlug": "day-030",
    "dayNumber": 30,
    "weekNumber": 6,
    "seder": "Moed",
    "tractate": "Eruvin",
    "voices": true,
    "label": "Fri, Oct 2, 2026 — Eruvin · Voices"
  },
  {
    "dateISO": "2026-10-05",
    "daySlug": "day-031",
    "dayNumber": 31,
    "weekNumber": 7,
    "seder": "Moed",
    "tractate": "Pesachim",
    "voices": false,
    "label": "Mon, Oct 5, 2026 — Pesachim"
  },
  {
    "dateISO": "2026-10-06",
    "daySlug": "day-032",
    "dayNumber": 32,
    "weekNumber": 7,
    "seder": "Moed",
    "tractate": "Pesachim",
    "voices": false,
    "label": "Tue, Oct 6, 2026 — Pesachim"
  },
  {
    "dateISO": "2026-10-07",
    "daySlug": "day-033",
    "dayNumber": 33,
    "weekNumber": 7,
    "seder": "Moed",
    "tractate": "Pesachim",
    "voices": false,
    "label": "Wed, Oct 7, 2026 — Pesachim"
  },
  {
    "dateISO": "2026-10-08",
    "daySlug": "day-034",
    "dayNumber": 34,
    "weekNumber": 7,
    "seder": "Moed",
    "tractate": "Pesachim",
    "voices": false,
    "label": "Thu, Oct 8, 2026 — Pesachim"
  },
  {
    "dateISO": "2026-10-09",
    "daySlug": "day-035",
    "dayNumber": 35,
    "weekNumber": 7,
    "seder": "Moed",
    "tractate": "Pesachim",
    "voices": true,
    "label": "Fri, Oct 9, 2026 — Pesachim · Voices"
  },
  {
    "dateISO": "2026-10-12",
    "daySlug": "day-036",
    "dayNumber": 36,
    "weekNumber": 8,
    "seder": "Moed",
    "tractate": "Yoma",
    "voices": false,
    "label": "Mon, Oct 12, 2026 — Yoma"
  },
  {
    "dateISO": "2026-10-13",
    "daySlug": "day-037",
    "dayNumber": 37,
    "weekNumber": 8,
    "seder": "Moed",
    "tractate": "Yoma",
    "voices": false,
    "label": "Tue, Oct 13, 2026 — Yoma"
  },
  {
    "dateISO": "2026-10-14",
    "daySlug": "day-038",
    "dayNumber": 38,
    "weekNumber": 8,
    "seder": "Moed",
    "tractate": "Yoma",
    "voices": false,
    "label": "Wed, Oct 14, 2026 — Yoma"
  },
  {
    "dateISO": "2026-10-15",
    "daySlug": "day-039",
    "dayNumber": 39,
    "weekNumber": 8,
    "seder": "Moed",
    "tractate": "Yoma",
    "voices": false,
    "label": "Thu, Oct 15, 2026 — Yoma"
  },
  {
    "dateISO": "2026-10-16",
    "daySlug": "day-040",
    "dayNumber": 40,
    "weekNumber": 8,
    "seder": "Moed",
    "tractate": "Yoma",
    "voices": true,
    "label": "Fri, Oct 16, 2026 — Yoma · Voices"
  },
  {
    "dateISO": "2026-10-19",
    "daySlug": "day-041",
    "dayNumber": 41,
    "weekNumber": 9,
    "seder": "Moed",
    "tractate": "Sukkah",
    "voices": false,
    "label": "Mon, Oct 19, 2026 — Sukkah"
  },
  {
    "dateISO": "2026-10-20",
    "daySlug": "day-042",
    "dayNumber": 42,
    "weekNumber": 9,
    "seder": "Moed",
    "tractate": "Sukkah",
    "voices": false,
    "label": "Tue, Oct 20, 2026 — Sukkah"
  },
  {
    "dateISO": "2026-10-21",
    "daySlug": "day-043",
    "dayNumber": 43,
    "weekNumber": 9,
    "seder": "Moed",
    "tractate": "Sukkah",
    "voices": false,
    "label": "Wed, Oct 21, 2026 — Sukkah"
  },
  {
    "dateISO": "2026-10-22",
    "daySlug": "day-044",
    "dayNumber": 44,
    "weekNumber": 9,
    "seder": "Moed",
    "tractate": "Sukkah",
    "voices": false,
    "label": "Thu, Oct 22, 2026 — Sukkah"
  },
  {
    "dateISO": "2026-10-23",
    "daySlug": "day-045",
    "dayNumber": 45,
    "weekNumber": 9,
    "seder": "Moed",
    "tractate": "Sukkah",
    "voices": true,
    "label": "Fri, Oct 23, 2026 — Sukkah · Voices"
  },
  {
    "dateISO": "2026-10-26",
    "daySlug": "day-046",
    "dayNumber": 46,
    "weekNumber": 10,
    "seder": "Moed",
    "tractate": "Beitzah",
    "voices": false,
    "label": "Mon, Oct 26, 2026 — Beitzah"
  },
  {
    "dateISO": "2026-10-27",
    "daySlug": "day-047",
    "dayNumber": 47,
    "weekNumber": 10,
    "seder": "Moed",
    "tractate": "Beitzah",
    "voices": false,
    "label": "Tue, Oct 27, 2026 — Beitzah"
  },
  {
    "dateISO": "2026-10-28",
    "daySlug": "day-048",
    "dayNumber": 48,
    "weekNumber": 10,
    "seder": "Moed",
    "tractate": "Beitzah",
    "voices": false,
    "label": "Wed, Oct 28, 2026 — Beitzah"
  },
  {
    "dateISO": "2026-10-29",
    "daySlug": "day-049",
    "dayNumber": 49,
    "weekNumber": 10,
    "seder": "Moed",
    "tractate": "Beitzah",
    "voices": false,
    "label": "Thu, Oct 29, 2026 — Beitzah"
  },
  {
    "dateISO": "2026-10-30",
    "daySlug": "day-050",
    "dayNumber": 50,
    "weekNumber": 10,
    "seder": "Moed",
    "tractate": "Beitzah",
    "voices": true,
    "label": "Fri, Oct 30, 2026 — Beitzah · Voices"
  },
  {
    "dateISO": "2026-11-02",
    "daySlug": "day-051",
    "dayNumber": 51,
    "weekNumber": 11,
    "seder": "Moed",
    "tractate": "Rosh Hashanah",
    "voices": false,
    "label": "Mon, Nov 2, 2026 — Rosh Hashanah"
  },
  {
    "dateISO": "2026-11-03",
    "daySlug": "day-052",
    "dayNumber": 52,
    "weekNumber": 11,
    "seder": "Moed",
    "tractate": "Rosh Hashanah",
    "voices": false,
    "label": "Tue, Nov 3, 2026 — Rosh Hashanah"
  },
  {
    "dateISO": "2026-11-04",
    "daySlug": "day-053",
    "dayNumber": 53,
    "weekNumber": 11,
    "seder": "Moed",
    "tractate": "Rosh Hashanah",
    "voices": false,
    "label": "Wed, Nov 4, 2026 — Rosh Hashanah"
  },
  {
    "dateISO": "2026-11-05",
    "daySlug": "day-054",
    "dayNumber": 54,
    "weekNumber": 11,
    "seder": "Moed",
    "tractate": "Rosh Hashanah",
    "voices": false,
    "label": "Thu, Nov 5, 2026 — Rosh Hashanah"
  },
  {
    "dateISO": "2026-11-06",
    "daySlug": "day-055",
    "dayNumber": 55,
    "weekNumber": 11,
    "seder": "Moed",
    "tractate": "Rosh Hashanah",
    "voices": true,
    "label": "Fri, Nov 6, 2026 — Rosh Hashanah · Voices"
  },
  {
    "dateISO": "2026-11-09",
    "daySlug": "day-056",
    "dayNumber": 56,
    "weekNumber": 12,
    "seder": "Moed",
    "tractate": "Taanis",
    "voices": false,
    "label": "Mon, Nov 9, 2026 — Taanis"
  },
  {
    "dateISO": "2026-11-10",
    "daySlug": "day-057",
    "dayNumber": 57,
    "weekNumber": 12,
    "seder": "Moed",
    "tractate": "Taanis",
    "voices": false,
    "label": "Tue, Nov 10, 2026 — Taanis"
  },
  {
    "dateISO": "2026-11-11",
    "daySlug": "day-058",
    "dayNumber": 58,
    "weekNumber": 12,
    "seder": "Moed",
    "tractate": "Taanis",
    "voices": false,
    "label": "Wed, Nov 11, 2026 — Taanis"
  },
  {
    "dateISO": "2026-11-12",
    "daySlug": "day-059",
    "dayNumber": 59,
    "weekNumber": 12,
    "seder": "Moed",
    "tractate": "Taanis",
    "voices": false,
    "label": "Thu, Nov 12, 2026 — Taanis"
  },
  {
    "dateISO": "2026-11-13",
    "daySlug": "day-060",
    "dayNumber": 60,
    "weekNumber": 12,
    "seder": "Moed",
    "tractate": "Taanis",
    "voices": true,
    "label": "Fri, Nov 13, 2026 — Taanis · Voices"
  },
  {
    "dateISO": "2026-11-16",
    "daySlug": "day-061",
    "dayNumber": 61,
    "weekNumber": 13,
    "seder": "Moed",
    "tractate": "Megillah",
    "voices": false,
    "label": "Mon, Nov 16, 2026 — Megillah"
  },
  {
    "dateISO": "2026-11-17",
    "daySlug": "day-062",
    "dayNumber": 62,
    "weekNumber": 13,
    "seder": "Moed",
    "tractate": "Megillah",
    "voices": false,
    "label": "Tue, Nov 17, 2026 — Megillah"
  },
  {
    "dateISO": "2026-11-18",
    "daySlug": "day-063",
    "dayNumber": 63,
    "weekNumber": 13,
    "seder": "Moed",
    "tractate": "Megillah",
    "voices": false,
    "label": "Wed, Nov 18, 2026 — Megillah"
  },
  {
    "dateISO": "2026-11-19",
    "daySlug": "day-064",
    "dayNumber": 64,
    "weekNumber": 13,
    "seder": "Moed",
    "tractate": "Megillah",
    "voices": false,
    "label": "Thu, Nov 19, 2026 — Megillah"
  },
  {
    "dateISO": "2026-11-20",
    "daySlug": "day-065",
    "dayNumber": 65,
    "weekNumber": 13,
    "seder": "Moed",
    "tractate": "Megillah",
    "voices": true,
    "label": "Fri, Nov 20, 2026 — Megillah · Voices"
  },
  {
    "dateISO": "2026-11-23",
    "daySlug": "day-066",
    "dayNumber": 66,
    "weekNumber": 14,
    "seder": "Moed",
    "tractate": "Moed Katan",
    "voices": false,
    "label": "Mon, Nov 23, 2026 — Moed Katan"
  },
  {
    "dateISO": "2026-11-24",
    "daySlug": "day-067",
    "dayNumber": 67,
    "weekNumber": 14,
    "seder": "Moed",
    "tractate": "Moed Katan",
    "voices": false,
    "label": "Tue, Nov 24, 2026 — Moed Katan"
  },
  {
    "dateISO": "2026-11-25",
    "daySlug": "day-068",
    "dayNumber": 68,
    "weekNumber": 14,
    "seder": "Moed",
    "tractate": "Moed Katan",
    "voices": false,
    "label": "Wed, Nov 25, 2026 — Moed Katan"
  },
  {
    "dateISO": "2026-11-26",
    "daySlug": "day-069",
    "dayNumber": 69,
    "weekNumber": 14,
    "seder": "Moed",
    "tractate": "Moed Katan",
    "voices": false,
    "label": "Thu, Nov 26, 2026 — Moed Katan"
  },
  {
    "dateISO": "2026-11-27",
    "daySlug": "day-070",
    "dayNumber": 70,
    "weekNumber": 14,
    "seder": "Moed",
    "tractate": "Moed Katan",
    "voices": true,
    "label": "Fri, Nov 27, 2026 — Moed Katan · Voices"
  },
  {
    "dateISO": "2026-11-30",
    "daySlug": "day-071",
    "dayNumber": 71,
    "weekNumber": 15,
    "seder": "Moed",
    "tractate": "Chagigah",
    "voices": false,
    "label": "Mon, Nov 30, 2026 — Chagigah"
  },
  {
    "dateISO": "2026-12-01",
    "daySlug": "day-072",
    "dayNumber": 72,
    "weekNumber": 15,
    "seder": "Moed",
    "tractate": "Chagigah",
    "voices": false,
    "label": "Tue, Dec 1, 2026 — Chagigah"
  },
  {
    "dateISO": "2026-12-02",
    "daySlug": "day-073",
    "dayNumber": 73,
    "weekNumber": 15,
    "seder": "Moed",
    "tractate": "Chagigah",
    "voices": false,
    "label": "Wed, Dec 2, 2026 — Chagigah"
  },
  {
    "dateISO": "2026-12-03",
    "daySlug": "day-074",
    "dayNumber": 74,
    "weekNumber": 15,
    "seder": "Moed",
    "tractate": "Chagigah",
    "voices": false,
    "label": "Thu, Dec 3, 2026 — Chagigah"
  },
  {
    "dateISO": "2026-12-04",
    "daySlug": "day-075",
    "dayNumber": 75,
    "weekNumber": 15,
    "seder": "Moed",
    "tractate": "Chagigah",
    "voices": true,
    "label": "Fri, Dec 4, 2026 — Chagigah · Voices"
  },
  {
    "dateISO": "2026-12-07",
    "daySlug": "day-076",
    "dayNumber": 76,
    "weekNumber": 16,
    "seder": "Nashim",
    "tractate": "Yevamos",
    "voices": false,
    "label": "Mon, Dec 7, 2026 — Yevamos"
  },
  {
    "dateISO": "2026-12-08",
    "daySlug": "day-077",
    "dayNumber": 77,
    "weekNumber": 16,
    "seder": "Nashim",
    "tractate": "Yevamos",
    "voices": false,
    "label": "Tue, Dec 8, 2026 — Yevamos"
  },
  {
    "dateISO": "2026-12-09",
    "daySlug": "day-078",
    "dayNumber": 78,
    "weekNumber": 16,
    "seder": "Nashim",
    "tractate": "Yevamos",
    "voices": false,
    "label": "Wed, Dec 9, 2026 — Yevamos"
  },
  {
    "dateISO": "2026-12-10",
    "daySlug": "day-079",
    "dayNumber": 79,
    "weekNumber": 16,
    "seder": "Nashim",
    "tractate": "Yevamos",
    "voices": false,
    "label": "Thu, Dec 10, 2026 — Yevamos"
  },
  {
    "dateISO": "2026-12-11",
    "daySlug": "day-080",
    "dayNumber": 80,
    "weekNumber": 16,
    "seder": "Nashim",
    "tractate": "Yevamos",
    "voices": true,
    "label": "Fri, Dec 11, 2026 — Yevamos · Voices"
  },
  {
    "dateISO": "2026-12-14",
    "daySlug": "day-081",
    "dayNumber": 81,
    "weekNumber": 17,
    "seder": "Nashim",
    "tractate": "Kesubos",
    "voices": false,
    "label": "Mon, Dec 14, 2026 — Kesubos"
  },
  {
    "dateISO": "2026-12-15",
    "daySlug": "day-082",
    "dayNumber": 82,
    "weekNumber": 17,
    "seder": "Nashim",
    "tractate": "Kesubos",
    "voices": false,
    "label": "Tue, Dec 15, 2026 — Kesubos"
  },
  {
    "dateISO": "2026-12-16",
    "daySlug": "day-083",
    "dayNumber": 83,
    "weekNumber": 17,
    "seder": "Nashim",
    "tractate": "Kesubos",
    "voices": false,
    "label": "Wed, Dec 16, 2026 — Kesubos"
  },
  {
    "dateISO": "2026-12-17",
    "daySlug": "day-084",
    "dayNumber": 84,
    "weekNumber": 17,
    "seder": "Nashim",
    "tractate": "Kesubos",
    "voices": false,
    "label": "Thu, Dec 17, 2026 — Kesubos"
  },
  {
    "dateISO": "2026-12-18",
    "daySlug": "day-085",
    "dayNumber": 85,
    "weekNumber": 17,
    "seder": "Nashim",
    "tractate": "Kesubos",
    "voices": true,
    "label": "Fri, Dec 18, 2026 — Kesubos · Voices"
  },
  {
    "dateISO": "2026-12-21",
    "daySlug": "day-086",
    "dayNumber": 86,
    "weekNumber": 18,
    "seder": "Nashim",
    "tractate": "Nedarim",
    "voices": false,
    "label": "Mon, Dec 21, 2026 — Nedarim"
  },
  {
    "dateISO": "2026-12-22",
    "daySlug": "day-087",
    "dayNumber": 87,
    "weekNumber": 18,
    "seder": "Nashim",
    "tractate": "Nedarim",
    "voices": false,
    "label": "Tue, Dec 22, 2026 — Nedarim"
  },
  {
    "dateISO": "2026-12-23",
    "daySlug": "day-088",
    "dayNumber": 88,
    "weekNumber": 18,
    "seder": "Nashim",
    "tractate": "Nedarim",
    "voices": false,
    "label": "Wed, Dec 23, 2026 — Nedarim"
  },
  {
    "dateISO": "2026-12-24",
    "daySlug": "day-089",
    "dayNumber": 89,
    "weekNumber": 18,
    "seder": "Nashim",
    "tractate": "Nedarim",
    "voices": false,
    "label": "Thu, Dec 24, 2026 — Nedarim"
  },
  {
    "dateISO": "2026-12-25",
    "daySlug": "day-090",
    "dayNumber": 90,
    "weekNumber": 18,
    "seder": "Nashim",
    "tractate": "Nedarim",
    "voices": true,
    "label": "Fri, Dec 25, 2026 — Nedarim · Voices"
  },
  {
    "dateISO": "2026-12-28",
    "daySlug": "day-091",
    "dayNumber": 91,
    "weekNumber": 19,
    "seder": "Nashim",
    "tractate": "Nazir",
    "voices": false,
    "label": "Mon, Dec 28, 2026 — Nazir"
  },
  {
    "dateISO": "2026-12-29",
    "daySlug": "day-092",
    "dayNumber": 92,
    "weekNumber": 19,
    "seder": "Nashim",
    "tractate": "Nazir",
    "voices": false,
    "label": "Tue, Dec 29, 2026 — Nazir"
  },
  {
    "dateISO": "2026-12-30",
    "daySlug": "day-093",
    "dayNumber": 93,
    "weekNumber": 19,
    "seder": "Nashim",
    "tractate": "Nazir",
    "voices": false,
    "label": "Wed, Dec 30, 2026 — Nazir"
  },
  {
    "dateISO": "2026-12-31",
    "daySlug": "day-094",
    "dayNumber": 94,
    "weekNumber": 19,
    "seder": "Nashim",
    "tractate": "Nazir",
    "voices": false,
    "label": "Thu, Dec 31, 2026 — Nazir"
  },
  {
    "dateISO": "2027-01-01",
    "daySlug": "day-095",
    "dayNumber": 95,
    "weekNumber": 19,
    "seder": "Nashim",
    "tractate": "Nazir",
    "voices": true,
    "label": "Fri, Jan 1, 2027 — Nazir · Voices"
  },
  {
    "dateISO": "2027-01-04",
    "daySlug": "day-096",
    "dayNumber": 96,
    "weekNumber": 20,
    "seder": "Nashim",
    "tractate": "Sotah",
    "voices": false,
    "label": "Mon, Jan 4, 2027 — Sotah"
  },
  {
    "dateISO": "2027-01-05",
    "daySlug": "day-097",
    "dayNumber": 97,
    "weekNumber": 20,
    "seder": "Nashim",
    "tractate": "Sotah",
    "voices": false,
    "label": "Tue, Jan 5, 2027 — Sotah"
  },
  {
    "dateISO": "2027-01-06",
    "daySlug": "day-098",
    "dayNumber": 98,
    "weekNumber": 20,
    "seder": "Nashim",
    "tractate": "Sotah",
    "voices": false,
    "label": "Wed, Jan 6, 2027 — Sotah"
  },
  {
    "dateISO": "2027-01-07",
    "daySlug": "day-099",
    "dayNumber": 99,
    "weekNumber": 20,
    "seder": "Nashim",
    "tractate": "Sotah",
    "voices": false,
    "label": "Thu, Jan 7, 2027 — Sotah"
  },
  {
    "dateISO": "2027-01-08",
    "daySlug": "day-100",
    "dayNumber": 100,
    "weekNumber": 20,
    "seder": "Nashim",
    "tractate": "Sotah",
    "voices": true,
    "label": "Fri, Jan 8, 2027 — Sotah · Voices"
  },
  {
    "dateISO": "2027-01-11",
    "daySlug": "day-101",
    "dayNumber": 101,
    "weekNumber": 21,
    "seder": "Nashim",
    "tractate": "Gittin",
    "voices": false,
    "label": "Mon, Jan 11, 2027 — Gittin"
  },
  {
    "dateISO": "2027-01-12",
    "daySlug": "day-102",
    "dayNumber": 102,
    "weekNumber": 21,
    "seder": "Nashim",
    "tractate": "Gittin",
    "voices": false,
    "label": "Tue, Jan 12, 2027 — Gittin"
  },
  {
    "dateISO": "2027-01-13",
    "daySlug": "day-103",
    "dayNumber": 103,
    "weekNumber": 21,
    "seder": "Nashim",
    "tractate": "Gittin",
    "voices": false,
    "label": "Wed, Jan 13, 2027 — Gittin"
  },
  {
    "dateISO": "2027-01-14",
    "daySlug": "day-104",
    "dayNumber": 104,
    "weekNumber": 21,
    "seder": "Nashim",
    "tractate": "Gittin",
    "voices": false,
    "label": "Thu, Jan 14, 2027 — Gittin"
  },
  {
    "dateISO": "2027-01-15",
    "daySlug": "day-105",
    "dayNumber": 105,
    "weekNumber": 21,
    "seder": "Nashim",
    "tractate": "Gittin",
    "voices": true,
    "label": "Fri, Jan 15, 2027 — Gittin · Voices"
  },
  {
    "dateISO": "2027-01-18",
    "daySlug": "day-106",
    "dayNumber": 106,
    "weekNumber": 22,
    "seder": "Nashim",
    "tractate": "Kiddushin",
    "voices": false,
    "label": "Mon, Jan 18, 2027 — Kiddushin"
  },
  {
    "dateISO": "2027-01-19",
    "daySlug": "day-107",
    "dayNumber": 107,
    "weekNumber": 22,
    "seder": "Nashim",
    "tractate": "Kiddushin",
    "voices": false,
    "label": "Tue, Jan 19, 2027 — Kiddushin"
  },
  {
    "dateISO": "2027-01-20",
    "daySlug": "day-108",
    "dayNumber": 108,
    "weekNumber": 22,
    "seder": "Nashim",
    "tractate": "Kiddushin",
    "voices": false,
    "label": "Wed, Jan 20, 2027 — Kiddushin"
  },
  {
    "dateISO": "2027-01-21",
    "daySlug": "day-109",
    "dayNumber": 109,
    "weekNumber": 22,
    "seder": "Nashim",
    "tractate": "Kiddushin",
    "voices": false,
    "label": "Thu, Jan 21, 2027 — Kiddushin"
  },
  {
    "dateISO": "2027-01-22",
    "daySlug": "day-110",
    "dayNumber": 110,
    "weekNumber": 22,
    "seder": "Nashim",
    "tractate": "Kiddushin",
    "voices": true,
    "label": "Fri, Jan 22, 2027 — Kiddushin · Voices"
  },
  {
    "dateISO": "2027-01-25",
    "daySlug": "day-111",
    "dayNumber": 111,
    "weekNumber": 23,
    "seder": "Nezikin",
    "tractate": "Bava Kamma",
    "voices": false,
    "label": "Mon, Jan 25, 2027 — Bava Kamma"
  },
  {
    "dateISO": "2027-01-26",
    "daySlug": "day-112",
    "dayNumber": 112,
    "weekNumber": 23,
    "seder": "Nezikin",
    "tractate": "Bava Kamma",
    "voices": false,
    "label": "Tue, Jan 26, 2027 — Bava Kamma"
  },
  {
    "dateISO": "2027-01-27",
    "daySlug": "day-113",
    "dayNumber": 113,
    "weekNumber": 23,
    "seder": "Nezikin",
    "tractate": "Bava Kamma",
    "voices": false,
    "label": "Wed, Jan 27, 2027 — Bava Kamma"
  },
  {
    "dateISO": "2027-01-28",
    "daySlug": "day-114",
    "dayNumber": 114,
    "weekNumber": 23,
    "seder": "Nezikin",
    "tractate": "Bava Kamma",
    "voices": false,
    "label": "Thu, Jan 28, 2027 — Bava Kamma"
  },
  {
    "dateISO": "2027-01-29",
    "daySlug": "day-115",
    "dayNumber": 115,
    "weekNumber": 23,
    "seder": "Nezikin",
    "tractate": "Bava Kamma",
    "voices": true,
    "label": "Fri, Jan 29, 2027 — Bava Kamma · Voices"
  },
  {
    "dateISO": "2027-02-01",
    "daySlug": "day-116",
    "dayNumber": 116,
    "weekNumber": 24,
    "seder": "Nezikin",
    "tractate": "Bava Metzia",
    "voices": false,
    "label": "Mon, Feb 1, 2027 — Bava Metzia"
  },
  {
    "dateISO": "2027-02-02",
    "daySlug": "day-117",
    "dayNumber": 117,
    "weekNumber": 24,
    "seder": "Nezikin",
    "tractate": "Bava Metzia",
    "voices": false,
    "label": "Tue, Feb 2, 2027 — Bava Metzia"
  },
  {
    "dateISO": "2027-02-03",
    "daySlug": "day-118",
    "dayNumber": 118,
    "weekNumber": 24,
    "seder": "Nezikin",
    "tractate": "Bava Metzia",
    "voices": false,
    "label": "Wed, Feb 3, 2027 — Bava Metzia"
  },
  {
    "dateISO": "2027-02-04",
    "daySlug": "day-119",
    "dayNumber": 119,
    "weekNumber": 24,
    "seder": "Nezikin",
    "tractate": "Bava Metzia",
    "voices": false,
    "label": "Thu, Feb 4, 2027 — Bava Metzia"
  },
  {
    "dateISO": "2027-02-05",
    "daySlug": "day-120",
    "dayNumber": 120,
    "weekNumber": 24,
    "seder": "Nezikin",
    "tractate": "Bava Metzia",
    "voices": true,
    "label": "Fri, Feb 5, 2027 — Bava Metzia · Voices"
  },
  {
    "dateISO": "2027-02-08",
    "daySlug": "day-121",
    "dayNumber": 121,
    "weekNumber": 25,
    "seder": "Nezikin",
    "tractate": "Bava Basra",
    "voices": false,
    "label": "Mon, Feb 8, 2027 — Bava Basra"
  },
  {
    "dateISO": "2027-02-09",
    "daySlug": "day-122",
    "dayNumber": 122,
    "weekNumber": 25,
    "seder": "Nezikin",
    "tractate": "Bava Basra",
    "voices": false,
    "label": "Tue, Feb 9, 2027 — Bava Basra"
  },
  {
    "dateISO": "2027-02-10",
    "daySlug": "day-123",
    "dayNumber": 123,
    "weekNumber": 25,
    "seder": "Nezikin",
    "tractate": "Bava Basra",
    "voices": false,
    "label": "Wed, Feb 10, 2027 — Bava Basra"
  },
  {
    "dateISO": "2027-02-11",
    "daySlug": "day-124",
    "dayNumber": 124,
    "weekNumber": 25,
    "seder": "Nezikin",
    "tractate": "Bava Basra",
    "voices": false,
    "label": "Thu, Feb 11, 2027 — Bava Basra"
  },
  {
    "dateISO": "2027-02-12",
    "daySlug": "day-125",
    "dayNumber": 125,
    "weekNumber": 25,
    "seder": "Nezikin",
    "tractate": "Bava Basra",
    "voices": true,
    "label": "Fri, Feb 12, 2027 — Bava Basra · Voices"
  },
  {
    "dateISO": "2027-02-15",
    "daySlug": "day-126",
    "dayNumber": 126,
    "weekNumber": 26,
    "seder": "Nezikin",
    "tractate": "Sanhedrin",
    "voices": false,
    "label": "Mon, Feb 15, 2027 — Sanhedrin"
  },
  {
    "dateISO": "2027-02-16",
    "daySlug": "day-127",
    "dayNumber": 127,
    "weekNumber": 26,
    "seder": "Nezikin",
    "tractate": "Sanhedrin",
    "voices": false,
    "label": "Tue, Feb 16, 2027 — Sanhedrin"
  },
  {
    "dateISO": "2027-02-17",
    "daySlug": "day-128",
    "dayNumber": 128,
    "weekNumber": 26,
    "seder": "Nezikin",
    "tractate": "Sanhedrin",
    "voices": false,
    "label": "Wed, Feb 17, 2027 — Sanhedrin"
  },
  {
    "dateISO": "2027-02-18",
    "daySlug": "day-129",
    "dayNumber": 129,
    "weekNumber": 26,
    "seder": "Nezikin",
    "tractate": "Sanhedrin",
    "voices": false,
    "label": "Thu, Feb 18, 2027 — Sanhedrin"
  },
  {
    "dateISO": "2027-02-19",
    "daySlug": "day-130",
    "dayNumber": 130,
    "weekNumber": 26,
    "seder": "Nezikin",
    "tractate": "Sanhedrin",
    "voices": true,
    "label": "Fri, Feb 19, 2027 — Sanhedrin · Voices"
  },
  {
    "dateISO": "2027-02-22",
    "daySlug": "day-131",
    "dayNumber": 131,
    "weekNumber": 27,
    "seder": "Nezikin",
    "tractate": "Makkos",
    "voices": false,
    "label": "Mon, Feb 22, 2027 — Makkos"
  },
  {
    "dateISO": "2027-02-23",
    "daySlug": "day-132",
    "dayNumber": 132,
    "weekNumber": 27,
    "seder": "Nezikin",
    "tractate": "Makkos",
    "voices": false,
    "label": "Tue, Feb 23, 2027 — Makkos"
  },
  {
    "dateISO": "2027-02-24",
    "daySlug": "day-133",
    "dayNumber": 133,
    "weekNumber": 27,
    "seder": "Nezikin",
    "tractate": "Makkos",
    "voices": false,
    "label": "Wed, Feb 24, 2027 — Makkos"
  },
  {
    "dateISO": "2027-02-25",
    "daySlug": "day-134",
    "dayNumber": 134,
    "weekNumber": 27,
    "seder": "Nezikin",
    "tractate": "Makkos",
    "voices": false,
    "label": "Thu, Feb 25, 2027 — Makkos"
  },
  {
    "dateISO": "2027-02-26",
    "daySlug": "day-135",
    "dayNumber": 135,
    "weekNumber": 27,
    "seder": "Nezikin",
    "tractate": "Makkos",
    "voices": true,
    "label": "Fri, Feb 26, 2027 — Makkos · Voices"
  },
  {
    "dateISO": "2027-03-01",
    "daySlug": "day-136",
    "dayNumber": 136,
    "weekNumber": 28,
    "seder": "Nezikin",
    "tractate": "Shevuos",
    "voices": false,
    "label": "Mon, Mar 1, 2027 — Shevuos"
  },
  {
    "dateISO": "2027-03-02",
    "daySlug": "day-137",
    "dayNumber": 137,
    "weekNumber": 28,
    "seder": "Nezikin",
    "tractate": "Shevuos",
    "voices": false,
    "label": "Tue, Mar 2, 2027 — Shevuos"
  },
  {
    "dateISO": "2027-03-03",
    "daySlug": "day-138",
    "dayNumber": 138,
    "weekNumber": 28,
    "seder": "Nezikin",
    "tractate": "Shevuos",
    "voices": false,
    "label": "Wed, Mar 3, 2027 — Shevuos"
  },
  {
    "dateISO": "2027-03-04",
    "daySlug": "day-139",
    "dayNumber": 139,
    "weekNumber": 28,
    "seder": "Nezikin",
    "tractate": "Shevuos",
    "voices": false,
    "label": "Thu, Mar 4, 2027 — Shevuos"
  },
  {
    "dateISO": "2027-03-05",
    "daySlug": "day-140",
    "dayNumber": 140,
    "weekNumber": 28,
    "seder": "Nezikin",
    "tractate": "Shevuos",
    "voices": true,
    "label": "Fri, Mar 5, 2027 — Shevuos · Voices"
  },
  {
    "dateISO": "2027-03-08",
    "daySlug": "day-141",
    "dayNumber": 141,
    "weekNumber": 29,
    "seder": "Nezikin",
    "tractate": "Avodah Zarah",
    "voices": false,
    "label": "Mon, Mar 8, 2027 — Avodah Zarah"
  },
  {
    "dateISO": "2027-03-09",
    "daySlug": "day-142",
    "dayNumber": 142,
    "weekNumber": 29,
    "seder": "Nezikin",
    "tractate": "Avodah Zarah",
    "voices": false,
    "label": "Tue, Mar 9, 2027 — Avodah Zarah"
  },
  {
    "dateISO": "2027-03-10",
    "daySlug": "day-143",
    "dayNumber": 143,
    "weekNumber": 29,
    "seder": "Nezikin",
    "tractate": "Avodah Zarah",
    "voices": false,
    "label": "Wed, Mar 10, 2027 — Avodah Zarah"
  },
  {
    "dateISO": "2027-03-11",
    "daySlug": "day-144",
    "dayNumber": 144,
    "weekNumber": 29,
    "seder": "Nezikin",
    "tractate": "Avodah Zarah",
    "voices": false,
    "label": "Thu, Mar 11, 2027 — Avodah Zarah"
  },
  {
    "dateISO": "2027-03-12",
    "daySlug": "day-145",
    "dayNumber": 145,
    "weekNumber": 29,
    "seder": "Nezikin",
    "tractate": "Avodah Zarah",
    "voices": true,
    "label": "Fri, Mar 12, 2027 — Avodah Zarah · Voices"
  },
  {
    "dateISO": "2027-03-15",
    "daySlug": "day-146",
    "dayNumber": 146,
    "weekNumber": 30,
    "seder": "Nezikin",
    "tractate": "Horayos",
    "voices": false,
    "label": "Mon, Mar 15, 2027 — Horayos"
  },
  {
    "dateISO": "2027-03-16",
    "daySlug": "day-147",
    "dayNumber": 147,
    "weekNumber": 30,
    "seder": "Nezikin",
    "tractate": "Horayos",
    "voices": false,
    "label": "Tue, Mar 16, 2027 — Horayos"
  },
  {
    "dateISO": "2027-03-17",
    "daySlug": "day-148",
    "dayNumber": 148,
    "weekNumber": 30,
    "seder": "Nezikin",
    "tractate": "Horayos",
    "voices": false,
    "label": "Wed, Mar 17, 2027 — Horayos"
  },
  {
    "dateISO": "2027-03-18",
    "daySlug": "day-149",
    "dayNumber": 149,
    "weekNumber": 30,
    "seder": "Nezikin",
    "tractate": "Horayos",
    "voices": false,
    "label": "Thu, Mar 18, 2027 — Horayos"
  },
  {
    "dateISO": "2027-03-19",
    "daySlug": "day-150",
    "dayNumber": 150,
    "weekNumber": 30,
    "seder": "Nezikin",
    "tractate": "Horayos",
    "voices": true,
    "label": "Fri, Mar 19, 2027 — Horayos · Voices"
  },
  {
    "dateISO": "2027-03-22",
    "daySlug": "day-151",
    "dayNumber": 151,
    "weekNumber": 31,
    "seder": "Kodashim",
    "tractate": "Zevachim",
    "voices": false,
    "label": "Mon, Mar 22, 2027 — Zevachim"
  },
  {
    "dateISO": "2027-03-23",
    "daySlug": "day-152",
    "dayNumber": 152,
    "weekNumber": 31,
    "seder": "Kodashim",
    "tractate": "Zevachim",
    "voices": false,
    "label": "Tue, Mar 23, 2027 — Zevachim"
  },
  {
    "dateISO": "2027-03-24",
    "daySlug": "day-153",
    "dayNumber": 153,
    "weekNumber": 31,
    "seder": "Kodashim",
    "tractate": "Zevachim",
    "voices": false,
    "label": "Wed, Mar 24, 2027 — Zevachim"
  },
  {
    "dateISO": "2027-03-25",
    "daySlug": "day-154",
    "dayNumber": 154,
    "weekNumber": 31,
    "seder": "Kodashim",
    "tractate": "Zevachim",
    "voices": false,
    "label": "Thu, Mar 25, 2027 — Zevachim"
  },
  {
    "dateISO": "2027-03-26",
    "daySlug": "day-155",
    "dayNumber": 155,
    "weekNumber": 31,
    "seder": "Kodashim",
    "tractate": "Zevachim",
    "voices": true,
    "label": "Fri, Mar 26, 2027 — Zevachim · Voices"
  },
  {
    "dateISO": "2027-03-29",
    "daySlug": "day-156",
    "dayNumber": 156,
    "weekNumber": 32,
    "seder": "Kodashim",
    "tractate": "Menachos",
    "voices": false,
    "label": "Mon, Mar 29, 2027 — Menachos"
  },
  {
    "dateISO": "2027-03-30",
    "daySlug": "day-157",
    "dayNumber": 157,
    "weekNumber": 32,
    "seder": "Kodashim",
    "tractate": "Menachos",
    "voices": false,
    "label": "Tue, Mar 30, 2027 — Menachos"
  },
  {
    "dateISO": "2027-03-31",
    "daySlug": "day-158",
    "dayNumber": 158,
    "weekNumber": 32,
    "seder": "Kodashim",
    "tractate": "Menachos",
    "voices": false,
    "label": "Wed, Mar 31, 2027 — Menachos"
  },
  {
    "dateISO": "2027-04-01",
    "daySlug": "day-159",
    "dayNumber": 159,
    "weekNumber": 32,
    "seder": "Kodashim",
    "tractate": "Menachos",
    "voices": false,
    "label": "Thu, Apr 1, 2027 — Menachos"
  },
  {
    "dateISO": "2027-04-02",
    "daySlug": "day-160",
    "dayNumber": 160,
    "weekNumber": 32,
    "seder": "Kodashim",
    "tractate": "Menachos",
    "voices": true,
    "label": "Fri, Apr 2, 2027 — Menachos · Voices"
  },
  {
    "dateISO": "2027-04-05",
    "daySlug": "day-161",
    "dayNumber": 161,
    "weekNumber": 33,
    "seder": "Kodashim",
    "tractate": "Chullin",
    "voices": false,
    "label": "Mon, Apr 5, 2027 — Chullin"
  },
  {
    "dateISO": "2027-04-06",
    "daySlug": "day-162",
    "dayNumber": 162,
    "weekNumber": 33,
    "seder": "Kodashim",
    "tractate": "Chullin",
    "voices": false,
    "label": "Tue, Apr 6, 2027 — Chullin"
  },
  {
    "dateISO": "2027-04-07",
    "daySlug": "day-163",
    "dayNumber": 163,
    "weekNumber": 33,
    "seder": "Kodashim",
    "tractate": "Chullin",
    "voices": false,
    "label": "Wed, Apr 7, 2027 — Chullin"
  },
  {
    "dateISO": "2027-04-08",
    "daySlug": "day-164",
    "dayNumber": 164,
    "weekNumber": 33,
    "seder": "Kodashim",
    "tractate": "Chullin",
    "voices": false,
    "label": "Thu, Apr 8, 2027 — Chullin"
  },
  {
    "dateISO": "2027-04-09",
    "daySlug": "day-165",
    "dayNumber": 165,
    "weekNumber": 33,
    "seder": "Kodashim",
    "tractate": "Chullin",
    "voices": true,
    "label": "Fri, Apr 9, 2027 — Chullin · Voices"
  },
  {
    "dateISO": "2027-04-12",
    "daySlug": "day-166",
    "dayNumber": 166,
    "weekNumber": 34,
    "seder": "Kodashim",
    "tractate": "Bechoros",
    "voices": false,
    "label": "Mon, Apr 12, 2027 — Bechoros"
  },
  {
    "dateISO": "2027-04-13",
    "daySlug": "day-167",
    "dayNumber": 167,
    "weekNumber": 34,
    "seder": "Kodashim",
    "tractate": "Bechoros",
    "voices": false,
    "label": "Tue, Apr 13, 2027 — Bechoros"
  },
  {
    "dateISO": "2027-04-14",
    "daySlug": "day-168",
    "dayNumber": 168,
    "weekNumber": 34,
    "seder": "Kodashim",
    "tractate": "Bechoros",
    "voices": false,
    "label": "Wed, Apr 14, 2027 — Bechoros"
  },
  {
    "dateISO": "2027-04-15",
    "daySlug": "day-169",
    "dayNumber": 169,
    "weekNumber": 34,
    "seder": "Kodashim",
    "tractate": "Bechoros",
    "voices": false,
    "label": "Thu, Apr 15, 2027 — Bechoros"
  },
  {
    "dateISO": "2027-04-16",
    "daySlug": "day-170",
    "dayNumber": 170,
    "weekNumber": 34,
    "seder": "Kodashim",
    "tractate": "Bechoros",
    "voices": true,
    "label": "Fri, Apr 16, 2027 — Bechoros · Voices"
  },
  {
    "dateISO": "2027-04-18",
    "daySlug": "day-171",
    "dayNumber": 171,
    "weekNumber": 35,
    "seder": "Kodashim",
    "tractate": "Arachin",
    "voices": false,
    "label": "Sun, Apr 18, 2027 — Arachin"
  },
  {
    "dateISO": "2027-04-19",
    "daySlug": "day-172",
    "dayNumber": 172,
    "weekNumber": 35,
    "seder": "Kodashim",
    "tractate": "Arachin",
    "voices": false,
    "label": "Mon, Apr 19, 2027 — Arachin"
  },
  {
    "dateISO": "2027-04-20",
    "daySlug": "day-173",
    "dayNumber": 173,
    "weekNumber": 35,
    "seder": "Kodashim",
    "tractate": "Arachin",
    "voices": false,
    "label": "Tue, Apr 20, 2027 — Arachin"
  },
  {
    "dateISO": "2027-04-21",
    "daySlug": "day-174",
    "dayNumber": 174,
    "weekNumber": 35,
    "seder": "Kodashim",
    "tractate": "Arachin",
    "voices": false,
    "label": "Wed, Apr 21, 2027 — Arachin"
  },
  {
    "dateISO": "2027-04-24",
    "daySlug": "day-175",
    "dayNumber": 175,
    "weekNumber": 35,
    "seder": "Kodashim",
    "tractate": "Arachin",
    "voices": true,
    "label": "Sat, Apr 24, 2027 — Arachin · Voices"
  },
  {
    "dateISO": "2027-04-25",
    "daySlug": "day-176",
    "dayNumber": 176,
    "weekNumber": 36,
    "seder": "Kodashim",
    "tractate": "Temurah",
    "voices": false,
    "label": "Sun, Apr 25, 2027 — Temurah"
  },
  {
    "dateISO": "2027-04-26",
    "daySlug": "day-177",
    "dayNumber": 177,
    "weekNumber": 36,
    "seder": "Kodashim",
    "tractate": "Temurah",
    "voices": false,
    "label": "Mon, Apr 26, 2027 — Temurah"
  },
  {
    "dateISO": "2027-04-27",
    "daySlug": "day-178",
    "dayNumber": 178,
    "weekNumber": 36,
    "seder": "Kodashim",
    "tractate": "Temurah",
    "voices": false,
    "label": "Tue, Apr 27, 2027 — Temurah"
  },
  {
    "dateISO": "2027-04-30",
    "daySlug": "day-179",
    "dayNumber": 179,
    "weekNumber": 36,
    "seder": "Kodashim",
    "tractate": "Temurah",
    "voices": false,
    "label": "Fri, Apr 30, 2027 — Temurah"
  },
  {
    "dateISO": "2027-05-01",
    "daySlug": "day-180",
    "dayNumber": 180,
    "weekNumber": 36,
    "seder": "Kodashim",
    "tractate": "Temurah",
    "voices": true,
    "label": "Sat, May 1, 2027 — Temurah · Voices"
  },
  {
    "dateISO": "2027-05-03",
    "daySlug": "day-181",
    "dayNumber": 181,
    "weekNumber": 37,
    "seder": "Kodashim",
    "tractate": "Kerisos",
    "voices": false,
    "label": "Mon, May 3, 2027 — Kerisos"
  },
  {
    "dateISO": "2027-05-04",
    "daySlug": "day-182",
    "dayNumber": 182,
    "weekNumber": 37,
    "seder": "Kodashim",
    "tractate": "Kerisos",
    "voices": false,
    "label": "Tue, May 4, 2027 — Kerisos"
  },
  {
    "dateISO": "2027-05-05",
    "daySlug": "day-183",
    "dayNumber": 183,
    "weekNumber": 37,
    "seder": "Kodashim",
    "tractate": "Kerisos",
    "voices": false,
    "label": "Wed, May 5, 2027 — Kerisos"
  },
  {
    "dateISO": "2027-05-06",
    "daySlug": "day-184",
    "dayNumber": 184,
    "weekNumber": 37,
    "seder": "Kodashim",
    "tractate": "Kerisos",
    "voices": false,
    "label": "Thu, May 6, 2027 — Kerisos"
  },
  {
    "dateISO": "2027-05-07",
    "daySlug": "day-185",
    "dayNumber": 185,
    "weekNumber": 37,
    "seder": "Kodashim",
    "tractate": "Kerisos",
    "voices": true,
    "label": "Fri, May 7, 2027 — Kerisos · Voices"
  },
  {
    "dateISO": "2027-05-10",
    "daySlug": "day-186",
    "dayNumber": 186,
    "weekNumber": 38,
    "seder": "Kodashim",
    "tractate": "Meilah",
    "voices": false,
    "label": "Mon, May 10, 2027 — Meilah"
  },
  {
    "dateISO": "2027-05-11",
    "daySlug": "day-187",
    "dayNumber": 187,
    "weekNumber": 38,
    "seder": "Kodashim",
    "tractate": "Meilah",
    "voices": false,
    "label": "Tue, May 11, 2027 — Meilah"
  },
  {
    "dateISO": "2027-05-12",
    "daySlug": "day-188",
    "dayNumber": 188,
    "weekNumber": 38,
    "seder": "Kodashim",
    "tractate": "Meilah",
    "voices": false,
    "label": "Wed, May 12, 2027 — Meilah"
  },
  {
    "dateISO": "2027-05-13",
    "daySlug": "day-189",
    "dayNumber": 189,
    "weekNumber": 38,
    "seder": "Kodashim",
    "tractate": "Meilah",
    "voices": false,
    "label": "Thu, May 13, 2027 — Meilah"
  },
  {
    "dateISO": "2027-05-14",
    "daySlug": "day-190",
    "dayNumber": 190,
    "weekNumber": 38,
    "seder": "Kodashim",
    "tractate": "Meilah",
    "voices": true,
    "label": "Fri, May 14, 2027 — Meilah · Voices"
  },
  {
    "dateISO": "2027-05-17",
    "daySlug": "day-191",
    "dayNumber": 191,
    "weekNumber": 39,
    "seder": "Kodashim",
    "tractate": "Tamid",
    "voices": false,
    "label": "Mon, May 17, 2027 — Tamid"
  },
  {
    "dateISO": "2027-05-18",
    "daySlug": "day-192",
    "dayNumber": 192,
    "weekNumber": 39,
    "seder": "Kodashim",
    "tractate": "Tamid",
    "voices": false,
    "label": "Tue, May 18, 2027 — Tamid"
  },
  {
    "dateISO": "2027-05-19",
    "daySlug": "day-193",
    "dayNumber": 193,
    "weekNumber": 39,
    "seder": "Kodashim",
    "tractate": "Tamid",
    "voices": false,
    "label": "Wed, May 19, 2027 — Tamid"
  },
  {
    "dateISO": "2027-05-20",
    "daySlug": "day-194",
    "dayNumber": 194,
    "weekNumber": 39,
    "seder": "Kodashim",
    "tractate": "Tamid",
    "voices": false,
    "label": "Thu, May 20, 2027 — Tamid"
  },
  {
    "dateISO": "2027-05-21",
    "daySlug": "day-195",
    "dayNumber": 195,
    "weekNumber": 39,
    "seder": "Kodashim",
    "tractate": "Tamid",
    "voices": true,
    "label": "Fri, May 21, 2027 — Tamid · Voices"
  },
  {
    "dateISO": "2027-05-24",
    "daySlug": "day-196",
    "dayNumber": 196,
    "weekNumber": 40,
    "seder": "Tahoros",
    "tractate": "Niddah",
    "voices": false,
    "label": "Mon, May 24, 2027 — Niddah"
  },
  {
    "dateISO": "2027-05-25",
    "daySlug": "day-197",
    "dayNumber": 197,
    "weekNumber": 40,
    "seder": "Tahoros",
    "tractate": "Niddah",
    "voices": false,
    "label": "Tue, May 25, 2027 — Niddah"
  },
  {
    "dateISO": "2027-05-26",
    "daySlug": "day-198",
    "dayNumber": 198,
    "weekNumber": 40,
    "seder": "Tahoros",
    "tractate": "Niddah",
    "voices": false,
    "label": "Wed, May 26, 2027 — Niddah"
  },
  {
    "dateISO": "2027-05-27",
    "daySlug": "day-199",
    "dayNumber": 199,
    "weekNumber": 40,
    "seder": "Tahoros",
    "tractate": "Niddah",
    "voices": false,
    "label": "Thu, May 27, 2027 — Niddah"
  },
  {
    "dateISO": "2027-05-28",
    "daySlug": "day-200",
    "dayNumber": 200,
    "weekNumber": 40,
    "seder": "Tahoros",
    "tractate": "Niddah",
    "voices": true,
    "label": "Fri, May 28, 2027 — Niddah · Voices"
  },
  {
    "dateISO": "2027-05-31",
    "daySlug": "day-201",
    "dayNumber": 201,
    "weekNumber": 41,
    "seder": "Wrap-up",
    "tractate": "Toward Siyum",
    "voices": false,
    "label": "Mon, May 31, 2027 — Toward Siyum"
  },
  {
    "dateISO": "2027-06-01",
    "daySlug": "day-202",
    "dayNumber": 202,
    "weekNumber": 41,
    "seder": "Wrap-up",
    "tractate": "Toward Siyum",
    "voices": false,
    "label": "Tue, Jun 1, 2027 — Toward Siyum"
  },
  {
    "dateISO": "2027-06-02",
    "daySlug": "day-203",
    "dayNumber": 203,
    "weekNumber": 41,
    "seder": "Wrap-up",
    "tractate": "Toward Siyum",
    "voices": false,
    "label": "Wed, Jun 2, 2027 — Toward Siyum"
  },
  {
    "dateISO": "2027-06-03",
    "daySlug": "day-204",
    "dayNumber": 204,
    "weekNumber": 41,
    "seder": "Wrap-up",
    "tractate": "Toward Siyum",
    "voices": false,
    "label": "Thu, Jun 3, 2027 — Toward Siyum"
  },
  {
    "dateISO": "2027-06-04",
    "daySlug": "day-205",
    "dayNumber": 205,
    "weekNumber": 41,
    "seder": "Wrap-up",
    "tractate": "Toward Siyum",
    "voices": true,
    "label": "Fri, Jun 4, 2027 — Toward Siyum · Voices"
  }
];

export const TD_WEEKS: TdWeekOption[] = [
  {
    "weekSlug": "week-01",
    "weekNumber": 1,
    "startISO": "2026-08-24",
    "endISO": "2026-08-28",
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "label": "Week 1: Foundations — Aug 24–28, 2026"
  },
  {
    "weekSlug": "week-02",
    "weekNumber": 2,
    "startISO": "2026-08-31",
    "endISO": "2026-09-04",
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "label": "Week 2: Foundations — Aug 31 – Sep 4, 2026"
  },
  {
    "weekSlug": "week-03",
    "weekNumber": 3,
    "startISO": "2026-09-07",
    "endISO": "2026-09-11",
    "seder": "Foundations (intro)",
    "tractate": "Foundations",
    "label": "Week 3: Foundations — Sep 7–11, 2026"
  },
  {
    "weekSlug": "week-04",
    "weekNumber": 4,
    "startISO": "2026-09-14",
    "endISO": "2026-09-18",
    "seder": "Zeraim",
    "tractate": "Brachos",
    "label": "Week 4: Brachos — Sep 14–18, 2026"
  },
  {
    "weekSlug": "week-05",
    "weekNumber": 5,
    "startISO": "2026-09-20",
    "endISO": "2026-09-25",
    "seder": "Moed",
    "tractate": "Shabbos",
    "label": "Week 5: Shabbos — Sep 20–25, 2026"
  },
  {
    "weekSlug": "week-06",
    "weekNumber": 6,
    "startISO": "2026-09-28",
    "endISO": "2026-10-02",
    "seder": "Moed",
    "tractate": "Eruvin",
    "label": "Week 6: Eruvin — Sep 28 – Oct 2, 2026"
  },
  {
    "weekSlug": "week-07",
    "weekNumber": 7,
    "startISO": "2026-10-05",
    "endISO": "2026-10-09",
    "seder": "Moed",
    "tractate": "Pesachim",
    "label": "Week 7: Pesachim — Oct 5–9, 2026"
  },
  {
    "weekSlug": "week-08",
    "weekNumber": 8,
    "startISO": "2026-10-12",
    "endISO": "2026-10-16",
    "seder": "Moed",
    "tractate": "Yoma",
    "label": "Week 8: Yoma — Oct 12–16, 2026"
  },
  {
    "weekSlug": "week-09",
    "weekNumber": 9,
    "startISO": "2026-10-19",
    "endISO": "2026-10-23",
    "seder": "Moed",
    "tractate": "Sukkah",
    "label": "Week 9: Sukkah — Oct 19–23, 2026"
  },
  {
    "weekSlug": "week-10",
    "weekNumber": 10,
    "startISO": "2026-10-26",
    "endISO": "2026-10-30",
    "seder": "Moed",
    "tractate": "Beitzah",
    "label": "Week 10: Beitzah — Oct 26–30, 2026"
  },
  {
    "weekSlug": "week-11",
    "weekNumber": 11,
    "startISO": "2026-11-02",
    "endISO": "2026-11-06",
    "seder": "Moed",
    "tractate": "Rosh Hashanah",
    "label": "Week 11: Rosh Hashanah — Nov 2–6, 2026"
  },
  {
    "weekSlug": "week-12",
    "weekNumber": 12,
    "startISO": "2026-11-09",
    "endISO": "2026-11-13",
    "seder": "Moed",
    "tractate": "Taanis",
    "label": "Week 12: Taanis — Nov 9–13, 2026"
  },
  {
    "weekSlug": "week-13",
    "weekNumber": 13,
    "startISO": "2026-11-16",
    "endISO": "2026-11-20",
    "seder": "Moed",
    "tractate": "Megillah",
    "label": "Week 13: Megillah — Nov 16–20, 2026"
  },
  {
    "weekSlug": "week-14",
    "weekNumber": 14,
    "startISO": "2026-11-23",
    "endISO": "2026-11-27",
    "seder": "Moed",
    "tractate": "Moed Katan",
    "label": "Week 14: Moed Katan — Nov 23–27, 2026"
  },
  {
    "weekSlug": "week-15",
    "weekNumber": 15,
    "startISO": "2026-11-30",
    "endISO": "2026-12-04",
    "seder": "Moed",
    "tractate": "Chagigah",
    "label": "Week 15: Chagigah — Nov 30 – Dec 4, 2026"
  },
  {
    "weekSlug": "week-16",
    "weekNumber": 16,
    "startISO": "2026-12-07",
    "endISO": "2026-12-11",
    "seder": "Nashim",
    "tractate": "Yevamos",
    "label": "Week 16: Yevamos — Dec 7–11, 2026"
  },
  {
    "weekSlug": "week-17",
    "weekNumber": 17,
    "startISO": "2026-12-14",
    "endISO": "2026-12-18",
    "seder": "Nashim",
    "tractate": "Kesubos",
    "label": "Week 17: Kesubos — Dec 14–18, 2026"
  },
  {
    "weekSlug": "week-18",
    "weekNumber": 18,
    "startISO": "2026-12-21",
    "endISO": "2026-12-25",
    "seder": "Nashim",
    "tractate": "Nedarim",
    "label": "Week 18: Nedarim — Dec 21–25, 2026"
  },
  {
    "weekSlug": "week-19",
    "weekNumber": 19,
    "startISO": "2026-12-28",
    "endISO": "2027-01-01",
    "seder": "Nashim",
    "tractate": "Nazir",
    "label": "Week 19: Nazir — Dec 28 – Jan 1, 2027"
  },
  {
    "weekSlug": "week-20",
    "weekNumber": 20,
    "startISO": "2027-01-04",
    "endISO": "2027-01-08",
    "seder": "Nashim",
    "tractate": "Sotah",
    "label": "Week 20: Sotah — Jan 4–8, 2027"
  },
  {
    "weekSlug": "week-21",
    "weekNumber": 21,
    "startISO": "2027-01-11",
    "endISO": "2027-01-15",
    "seder": "Nashim",
    "tractate": "Gittin",
    "label": "Week 21: Gittin — Jan 11–15, 2027"
  },
  {
    "weekSlug": "week-22",
    "weekNumber": 22,
    "startISO": "2027-01-18",
    "endISO": "2027-01-22",
    "seder": "Nashim",
    "tractate": "Kiddushin",
    "label": "Week 22: Kiddushin — Jan 18–22, 2027"
  },
  {
    "weekSlug": "week-23",
    "weekNumber": 23,
    "startISO": "2027-01-25",
    "endISO": "2027-01-29",
    "seder": "Nezikin",
    "tractate": "Bava Kamma",
    "label": "Week 23: Bava Kamma — Jan 25–29, 2027"
  },
  {
    "weekSlug": "week-24",
    "weekNumber": 24,
    "startISO": "2027-02-01",
    "endISO": "2027-02-05",
    "seder": "Nezikin",
    "tractate": "Bava Metzia",
    "label": "Week 24: Bava Metzia — Feb 1–5, 2027"
  },
  {
    "weekSlug": "week-25",
    "weekNumber": 25,
    "startISO": "2027-02-08",
    "endISO": "2027-02-12",
    "seder": "Nezikin",
    "tractate": "Bava Basra",
    "label": "Week 25: Bava Basra — Feb 8–12, 2027"
  },
  {
    "weekSlug": "week-26",
    "weekNumber": 26,
    "startISO": "2027-02-15",
    "endISO": "2027-02-19",
    "seder": "Nezikin",
    "tractate": "Sanhedrin",
    "label": "Week 26: Sanhedrin — Feb 15–19, 2027"
  },
  {
    "weekSlug": "week-27",
    "weekNumber": 27,
    "startISO": "2027-02-22",
    "endISO": "2027-02-26",
    "seder": "Nezikin",
    "tractate": "Makkos",
    "label": "Week 27: Makkos — Feb 22–26, 2027"
  },
  {
    "weekSlug": "week-28",
    "weekNumber": 28,
    "startISO": "2027-03-01",
    "endISO": "2027-03-05",
    "seder": "Nezikin",
    "tractate": "Shevuos",
    "label": "Week 28: Shevuos — Mar 1–5, 2027"
  },
  {
    "weekSlug": "week-29",
    "weekNumber": 29,
    "startISO": "2027-03-08",
    "endISO": "2027-03-12",
    "seder": "Nezikin",
    "tractate": "Avodah Zarah",
    "label": "Week 29: Avodah Zarah — Mar 8–12, 2027"
  },
  {
    "weekSlug": "week-30",
    "weekNumber": 30,
    "startISO": "2027-03-15",
    "endISO": "2027-03-19",
    "seder": "Nezikin",
    "tractate": "Horayos",
    "label": "Week 30: Horayos — Mar 15–19, 2027"
  },
  {
    "weekSlug": "week-31",
    "weekNumber": 31,
    "startISO": "2027-03-22",
    "endISO": "2027-03-26",
    "seder": "Kodashim",
    "tractate": "Zevachim",
    "label": "Week 31: Zevachim — Mar 22–26, 2027"
  },
  {
    "weekSlug": "week-32",
    "weekNumber": 32,
    "startISO": "2027-03-29",
    "endISO": "2027-04-02",
    "seder": "Kodashim",
    "tractate": "Menachos",
    "label": "Week 32: Menachos — Mar 29 – Apr 2, 2027"
  },
  {
    "weekSlug": "week-33",
    "weekNumber": 33,
    "startISO": "2027-04-05",
    "endISO": "2027-04-09",
    "seder": "Kodashim",
    "tractate": "Chullin",
    "label": "Week 33: Chullin — Apr 5–9, 2027"
  },
  {
    "weekSlug": "week-34",
    "weekNumber": 34,
    "startISO": "2027-04-12",
    "endISO": "2027-04-16",
    "seder": "Kodashim",
    "tractate": "Bechoros",
    "label": "Week 34: Bechoros — Apr 12–16, 2027"
  },
  {
    "weekSlug": "week-35",
    "weekNumber": 35,
    "startISO": "2027-04-18",
    "endISO": "2027-04-24",
    "seder": "Kodashim",
    "tractate": "Arachin",
    "label": "Week 35: Arachin — Apr 18–24, 2027"
  },
  {
    "weekSlug": "week-36",
    "weekNumber": 36,
    "startISO": "2027-04-25",
    "endISO": "2027-05-01",
    "seder": "Kodashim",
    "tractate": "Temurah",
    "label": "Week 36: Temurah — Apr 25 – May 1, 2027"
  },
  {
    "weekSlug": "week-37",
    "weekNumber": 37,
    "startISO": "2027-05-03",
    "endISO": "2027-05-07",
    "seder": "Kodashim",
    "tractate": "Kerisos",
    "label": "Week 37: Kerisos — May 3–7, 2027"
  },
  {
    "weekSlug": "week-38",
    "weekNumber": 38,
    "startISO": "2027-05-10",
    "endISO": "2027-05-14",
    "seder": "Kodashim",
    "tractate": "Meilah",
    "label": "Week 38: Meilah — May 10–14, 2027"
  },
  {
    "weekSlug": "week-39",
    "weekNumber": 39,
    "startISO": "2027-05-17",
    "endISO": "2027-05-21",
    "seder": "Kodashim",
    "tractate": "Tamid",
    "label": "Week 39: Tamid — May 17–21, 2027"
  },
  {
    "weekSlug": "week-40",
    "weekNumber": 40,
    "startISO": "2027-05-24",
    "endISO": "2027-05-28",
    "seder": "Tahoros",
    "tractate": "Niddah",
    "label": "Week 40: Niddah — May 24–28, 2027"
  },
  {
    "weekSlug": "week-41",
    "weekNumber": 41,
    "startISO": "2027-05-31",
    "endISO": "2027-06-04",
    "seder": "Wrap-up",
    "tractate": "Toward Siyum — Reflection & prep for Jun 6",
    "label": "Week 41: Toward Siyum — Reflection & prep for Jun 6 — May 31 – Jun 4, 2027"
  }
];
